<div class="header">
  <img src="assets/logo_ginemed.png" height="90" />
</div>
<div class="home">
  <form role="form" class="container" [formGroup]="parts" (submit)="doCreateRoom()" *ngIf="!url">
    <div class="info">
      Introduzca los datos de la persona con la que quiere establecer una video consulta
    </div>
    <div class="form-item">
      <input type="text" formControlName="telephone" tabindex="0" autofocus="on" placeholder="Teléfono" />
      <div class="error" *ngIf="hasError('telephone','pattern') && (isDirty('telephone') || isTouched('telephone'))">El teléfono introducido no es válido</div>
    </div>
    <div class="form-item">
      <input type="text" formControlName="email" tabindex="0" autofocus="on" placeholder="Correo electrónico" />
      <div class="error" *ngIf="hasError('email','email') && (isDirty('email') || isTouched('email'))">El correo electrónico introducido no es válido</div>
    </div>
    <div class="form-item button">
      <button type="submit" [disabled]="!parts.valid" tabindex="0">Enviar solicitud</button>
    </div>
    <div class="error-one-field-required" *ngIf="parts.hasError('oneFieldRequired') && (isDirty('telephone') || isTouched('telephone') || isDirty('email') || isTouched('email'))">Es necesario introducir el teléfono o el correo electrónico</div>
  </form>

  <div class="room-controls" *ngIf="url">
    <div class="item invitacion-correcta">Invitación enviada correctamente.</div>
    <div class="item button-controller">
      <div class="button-back">
        <button type="submit" [disabled]="!parts.valid" tabindex="0" (click)="doReturn()">Volver</button>
      </div>
      <div class="button-enter">
        <button type="submit" [disabled]="!parts.valid" tabindex="0" (click)="doEnterRoom()">Entrar a la sala</button>
      </div>
    </div>
  </div>
</div>